export default __webpack_public_path__ + "static/media/kadchmaLogo.f7c94f3e.png";